import { defineMessages } from 'react-intl';

export default defineMessages({
  logout: 'Wyloguj',
});
